// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3YV8_","emails":"CreateEditClinics_emails__9SK8R","emailTagLabel":"CreateEditClinics_emailTagLabel__2PRMG"};